import React from "react";

import Card from "./card-component";
import { colors } from "../lib/constants";
import { useMobile } from "../helperFunctions";

export default function Sphere(props) {
  const { position, keyphrase, groupName, taxon, color } = props;
  const mobile = useMobile();
  const mesh = React.useRef();
  const [hover, setHover] = React.useState(false);

  const onHover = React.useCallback(() => {
    if (mobile === false) {
      setHover(!hover);
    }
  }, [setHover, hover, mobile]);

  const mobileClick = React.useCallback(() => {
    if (mobile === true) {
      setHover(!hover);
    }
  }, [setHover, hover, mobile]);

  return (
    <mesh ref={mesh} position={position} onPointerOver={onHover} onPointerOut={onHover} onPointerDown={mobileClick}>
      <icosahedronGeometry attach="geometry" args={[0.375, 5]} />
      <meshStandardMaterial attach="material" color={color ? color : colors.noGroup} />
      <Card
        text={keyphrase}
        position={position}
        hover={hover}
        taxon={taxon}
        color={color}
        key={`tag-card-${position}`}
        groupName={groupName ? groupName : "noGroup"}
      />
    </mesh>
  );
}
